import React from "react";

export interface ButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {}

const Button: React.FC<ButtonProps> = ({ ...props }) => (
  <button className="fl-p-4 fl-bg-primary fl-rounded-md" {...props} />
);

export default Button;
